import React from "react";
import { useEffect,useRef, useCallback } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { getUser } from "../../utils/localStorage";

import api from "../../utils/api";
import { useState } from "react";

import { toast } from "react-toastify";
import Spinner from "../../common/Spinner/Spinner";
import { ControlledInput } from "../../common/Input/Input";
import { Button } from "../../common/Button/Button";
import Select from "react-select";
import select_arrow_down from "../../assets/select_arrow_down.svg";
//import ColumnSectionDropdown from "../../components/ServiceRequests/Admin/ColumnSelectionDropdown";
import RadioSelectionDropdown from "../../components/ServiceRequests/Admin/RadioSelectionDropdown";
import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
import UserDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserDetails";
import NotesModalThreeSixtyDegreeView from "../../components/ServiceRequests/ThreeSixtyDegreeView/NotesModalThreeSixtyDegreeView";
//import ServiceDetailsContainer from "./ServiceDetailsContainer";
import ServicessDetailsContainer from "./ServicessDetailsContainer";
import { useLocation } from "react-router-dom";
import Radio from "../../common/Radio/Radio.jsx";
import UserProfileModal from "../../components/ServiceRequests/Handholder/UserProfileModal";
import ProfileThreeSixtyModal from "../../components/ServiceRequests/Handholder/ProfileThreeSixtyModal";
//import RadioOption from "../../components/ServiceRequests/Admin/RadioOptions";
import CentralizedSMSLogModal from "../../components/ServiceRequests/Handholder/CentralizedSMSLogModel";
import FacilitatorThreeSixtyModel from '../../components/ServiceRequests/Handholder/FacilitatorThreeSixtyModel.jsx'
import UserssDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserssDetails";
import ServiceDetailsNewContainer from "./ServiceDetailsNewContainer.jsx";
import NotesLPMModalThreeSixtyDegreeView from "../../components/ServiceRequests/ThreeSixtyDegreeView/NotesLPMModalThreeSixtyDegreeView.jsx";
 
function useQuery() {
	return new URLSearchParams(useLocation().search);
}

export default function ThreeSixtyDegreeViewContainerNew(props) {
	const params = useQuery();
	const [isLoading, setIsLoading] = useState(false);

	const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	const phonePattern = /^\d{10}$/;
	const [totalUsers, setTotalUsers] = useState([]);
	const [isLoadingServicesLPM, setIsLoadingServicesLPM] = useState(false);
	const [isLoadingServicesSPM, setIsLoadingServicesSPM] = useState(false);

	const [servicesLPM, setServicesLPM] = useState([]);
	const [servicesLPMCount, setServicesLPMCount] = useState(0);
	const [servicesLPMByUserId, setServicesLPMByUserId] = useState({});
	const [servicesLPMByUserIdNew, setServicesLPMByUserIdNew] = useState({});


	const [servicesSPMSectionA, setServicesSPMSectionA] = useState([]);
	const [ServicesSPMSectionACount, setServicesSPMSectionACount] = useState(0);
	const [
		servicesSPMSectionAByUserId,
		setServicesSPMSectionAByUserId,
	] = useState({});

	const [servicesSPMSectionB, setServicesSPMSectionB] = useState([]);
	const [ServicesSPMSectionBCount, setServicesSPMSectionBCount] = useState(0);
	const [
		servicesSPMSectionBByUserId,
		setServicesSPMSectionBByUserId,
	] = useState({});

	const [servicesLS, setServicesLS] = useState([]);
	const [servicesLSSorted, setServicesLSSorted] = useState([]);

	const pagination = false;

	const [userData, setUserData] = useState();
	const [userDataWP, setUserDataWP] = useState([]);
	const [userDataWPByUserId, setUserDataWPByUserId] = useState([]);
	//const [nUserId, setNUserId] = useState();

	const [searchFilter, setSearchFilter] = useState();
	const onSearchFilterChange = (option) => {
		setSearchFilter(option);
	};
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [selectedService, setSelectedService] = useState();
	const [notesDetails, setNotesDetails] = useState({
		sFollowupAction: "",
		dtFollowupOn: "",
		sNotes: "",
	});
	const [showLPMNotesModal, setShowLPMNotesModal] = useState(false);
	const [notesDetailsLPM, setNotesDetailsLPM] = useState({
		sFollowupNotes: "",
		dtFollowupOn: "",
		sNotes: "",
	});
  const [searchTermTemp, setSearchTermTemp] = useState("");
  const [searchFacTerm, setSearchFacTerm] = useState("");
  const [facilitatorData, setFacilitatorData] = useState([]);
  const [facilitatorModalVisibility, setFacilitatorModalVisibility] = useState(false);
	const [selectedCustomerEmailForNotes, setselectedCustomerEmailForNotes] = useState(null);
	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
  const [LPMServices, setLPMServices] = useState([]);
  const [SPMServices, setSPMServices] = useState([]);
	const toggleViewAllNotesModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};

  const [SearchByFacilitatorDropdownList, setSearchByFacilitatorDropdownList] = useState([
    { checked: false, label: "Service Instance ID", id: "InstanceID", code: "InstanceID" },
    { checked: false, label: "Customer Email ID", id: "CustomerEmailID", code: "CustomerEmailID" },
    { checked: false, label: "Phone Number", id: "PhoneNumber", code: "PhoneNumber" },
  ]);
  const [SearchByServiceDropdownList, setSearchByServiceDropdownList] = useState([
    { checked: true, label: "Facilitator", id: "Facilitator", code: "Facilitator" },
    { checked: false, label: "Service Request", id: "Service_Request", code: "Service_Request" },
  ]);

  const [isSearchByFacilitatorDropdownOpen, setIsSearchByFacilitatorDropdownOpen] = useState(false);
  const [isSearchByServiceDropdownOpen, setisSearchByServiceDropdownOpen] = useState(false);
  const [disableFacilitatorButton, setDisableFacilitatorButton] = useState(false);
  const [activeSearchType, setActiveSearchType] = useState("primary");

  const SearchDropdownFacilitatorRef = useRef();
  const SearchDropdownServiceRef = useRef();

  const toggleSearchByFacilitatorVisibility = useCallback(() => setIsSearchByFacilitatorDropdownOpen((v) => !v), []);
  const toggleSearchByServiceVisibility = useCallback(() => setisSearchByServiceDropdownOpen((v) => !v), []);

	const [selectedSearchBy, setSelectedSearchBy] = useState('email');
	const [mobile, setMobile] = useState("")
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);
	const [pendingSelectionSearchByLeft, setPendingSelectionSearchByLeft] = useState(null);
	const [pendingSelectionSearchByRight, setPendingSelectionSearchByRight] = useState(null);
	const [pendingSelectionSearchType, setPendingSelectionSearchType] = useState(null);
	const [pendingSearchAction, setPendingSearchAction] = useState(null);
	const [isThreeSixtyUser, setIsThreeSixtyUser] = useState(false);
	const requestVersionRef = useRef(0);


  const handleSearchFacInputChange = useCallback(({ target: { value } }) => {
    setSearchFacTerm(value);
    if (!searchFilter) {
      // same as above
    }
    if (phonePattern.test(value)) setDisableFacilitatorButton(false);
    else if (emailPattern.test(value)) setDisableFacilitatorButton(true);
    else setDisableFacilitatorButton(false);
  }, [searchFilter]);

  const selectSearchByFacilitatorSelection = (e) => {
	  if (hasSearchResults()) {
		setPendingSelectionSearchByRight(e);
		setShowConfirmPopup(true);
		return;
	}
    setSearchByFacilitatorDropdownList((prev) => prev.map((x) => ({ ...x, checked: x.code === e ? !x.checked : false })));
    if (e === "CustomerEmailID") setDisableFacilitatorButton(true);
    else setDisableFacilitatorButton(false);
  };

  const selectSearchByServiceSelection = (e) => {
	if (hasSearchResults()) {
		setPendingSelectionSearchType(e);
		setShowConfirmPopup(true);
		return;
	}
    setSearchByServiceDropdownList((prev) => prev.map((x) => ({ ...x, checked: x.code === e ? !x.checked : false })));
    if (e === "CustomerEmailID") setDisableFacilitatorButton(true);
    else setDisableFacilitatorButton(false);
  };
  const hasSearchResults = () => {
	return (
	  totalUsers?.length > 0 ||
	  servicesLPM.length > 0 ||
	  servicesSPMSectionA.length > 0 ||
	  servicesSPMSectionB.length > 0 ||
	  servicesLS.length > 0
	);
  };




	const sortServicesLSold = () => {
		let searchParam =
			searchTerm && emailPattern.test(searchTerm) === "email"
				? "sEmailAddress"
				: "sContactNumber";
				if(selectedSearchBy==="InstanceID")
				{
					searchParam="nResourceInstanceId";
				}
				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchParam="sEmailAddress";
				// }
		let searchParamLS =
			searchParam === "sEmailAddress" ? "EmailAddress" : "Phone";
		let temp = [];
		for (var i = 0; i < servicesLS.length; i++) {
			servicesLPM.map((s) => {
				if (
					s[`${searchParam}`] === servicesLS[i][`${searchParamLS}`] ||
					(servicesLS[i][`${searchParamLS}`] && s[`${searchParam}`] ===
						servicesLS[i][`${searchParamLS}`].split("-")[1])
				) {
					servicesLS[i]["nUserId"] = s["nUserId"];
				}
			});
			temp.push(servicesLS[i]);
		}
		let temp1 = [];
		if (servicesLS.length !== 0) {
			temp1 = servicesLS.reduce((r, a) => {
				r[a.EmailAddress] = r[a.EmailAddress] || [];
				r[a.EmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLSSorted(temp1);
	};

	const sortServicesLS = () => {
		if (!servicesLS || servicesLS.length === 0) {
		  setServicesLSSorted([]);
		  return;
		}
	  
		let searchParam =
		  searchTerm && emailPattern.test(searchTerm) === "email"
			? "sEmailAddress"
			: "sContactNumber";
	  
		if (selectedSearchBy === "InstanceID") {
		  searchParam = "nResourceInstanceId";
		}
	  
		let searchParamLS =
		  searchParam === "sEmailAddress" ? "EmailAddress" : "Phone";
	  
		const lpmMap = {};
		for (const s of servicesLPM) {
		  lpmMap[s[searchParam]] = s.nUserId;
		}
	  
		const merged = servicesLS.map((item) => {
		  const key = item[searchParamLS];
		  if (key) {
			const parts = key.split("-");
			item.nUserId = lpmMap[key] || lpmMap[parts[1]] || item.nUserId;
		  }
		  return item;
		});
	  
		const grouped = merged.reduce((acc, a) => {
		  if (!acc[a.EmailAddress]) acc[a.EmailAddress] = [];
		  acc[a.EmailAddress].push(a);
		  return acc;
		}, {});
	  
		setServicesLSSorted(grouped);
	  };
	  

	const sortUserDataByUserId = () => {
		let temp = [];
		// console.log("WP data", userDataWP.data);

		if (
			userDataWP.data !== undefined &&
			userDataWP.data.data !== null &&
			Object.keys(userDataWP).length > 0
		) {
			temp = userDataWP.data.data.reduce((r, a) => {
				r[a.email] = r[a.email] || [];
				r[a.email].push(a);
				return r;
			}, Object.create(null));
		}
		setUserDataWPByUserId(temp);
	};

	const sortServicesLPMByUserId = () => {
		let temp = [];
		temp = servicesLPM.filter((e) => e.bMovedToSPM === false);
		if (temp.length !== 0) {
			temp = temp.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				r[a.sEmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLPMByUserId(temp);
	};
	const [existIDs, setExistIDs] = useState([]);
	const sortServicesSPMSectionAByUserId = () => {
		let temp = [];
		let ids = [];
		if (servicesSPMSectionA.length !== 0) {
			temp = servicesSPMSectionA.reduce((r, a) => {
				r[a.sEmailAddressOrigin] = r[a.sEmailAddressOrigin] || [];
				r[a.sEmailAddressOrigin].push(a);
				ids.push(a.nResourceInstanceId)
				return r;
			}, Object.create(null));
		}
		setExistIDs(ids);
		setServicesSPMSectionAByUserId(temp);
	};

	const sortServicesSPMSectionBByUserId = () => {
		let temp = [];
		let email_id = "";
		if (servicesSPMSectionB.length !== 0) {
			temp = servicesSPMSectionB.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				email_id = a.sEmailAddress;
				if (!existIDs.includes(a.nResourceInstanceId)) {
					r[a.sEmailAddress].push(a);
				}
				return r;

			}, Object.create(null));
		}

		if (email_id !== "") {
			temp[email_id].length === 0 ? setServicesSPMSectionBByUserId([]) : setServicesSPMSectionBByUserId(temp);
		}
		else {
			setServicesSPMSectionBByUserId([]);
		}
	};


	const toggleNotesModal = (nResourceInstasnceId) => {
		setSelectedService(nResourceInstasnceId);
		setShowNotesModal(!showNotesModal);
		setNotesDetails({
			sFollowupAction: "",
			dtFollowupOn: "",
			sNotes: "",
		});
	};
	const toggleLPMNotesModal = (nResourceInstasnceId) => {
		setSelectedService(nResourceInstasnceId);
		setShowLPMNotesModal(!showLPMNotesModal);
		setNotesDetailsLPM({
			sFollowupNotes: "",
			dtFollowupOn: "",
			sNotes: "",
		});
	};
	const onInputChange = (name, value) => {
		const updated = { ...notesDetails, [name]: value };
		setNotesDetails(updated);
	};
	const onLPMInputChange = (name, value) => {
		const updated = { ...notesDetailsLPM, [name]: value };
		setNotesDetailsLPM(updated);
	};
	const onSaveNotesDetails = async () => {
		if (
			notesDetails["sNotes"] === "" ||
			notesDetails["sNotes"] === undefined ||
			notesDetails["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(notesDetails["dtFollowupOn"] && notesDetails["sFollowupAction"])
		) {
			if (
				(notesDetails["sFollowupAction"] === "" ||
					notesDetails["sFollowupAction"] === null ||
					notesDetails["sFollowupAction"] === undefined) &&
				(notesDetails["dtFollowupOn"] === "" ||
					notesDetails["dtFollowupOn"] === undefined ||
					notesDetails["dtFollowupOn"] === null)
			) {
			} else if (
				notesDetails["dtFollowupOn"] === "" ||
				notesDetails["dtFollowupOn"] === undefined ||
				notesDetails["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				notesDetails["sFollowupAction"] === "" ||
				notesDetails["sFollowupAction"] === undefined ||
				notesDetails["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {
			if (true) {
				setIsLoading(true)
				let data = await api
					.saveNotes({
						...notesDetails,
						nResourceInstanceId:
							selectedService["nResourceInstanceId"],
					})
					.then(() => {
						setIsLoading(false)
						toast("Note saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					});

				setNotesDetails({
					sFollowupAction: "",
					dtFollowupOn: "",
					sNotes: "",
				});
			}
			toggleNotesModal();
		} catch (error) {
			setIsLoading(false)
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const onSaveLPMNotesDetails = async () => {
		if (
			notesDetailsLPM["sNotes"] === "" ||
			notesDetailsLPM["sNotes"] === undefined ||
			notesDetailsLPM["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(notesDetailsLPM["dtFollowupOn"] && notesDetailsLPM["sFollowupNotes"])
		) {
			if (
				(notesDetailsLPM["sFollowupNotes"] === "" ||
					notesDetailsLPM["sFollowupNotes"] === null ||
					notesDetailsLPM["sFollowupNotes"] === undefined) &&
				(notesDetailsLPM["dtFollowupOn"] === "" ||
					notesDetailsLPM["dtFollowupOn"] === undefined ||
					notesDetailsLPM["dtFollowupOn"] === null)
			) {
			} else if (
				notesDetailsLPM["dtFollowupOn"] === "" ||
				notesDetailsLPM["dtFollowupOn"] === undefined ||
				notesDetailsLPM["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				notesDetailsLPM["sFollowupNotes"] === "" ||
				notesDetailsLPM["sFollowupNotes"] === undefined ||
				notesDetailsLPM["sFollowupNotes"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {
			if (true) {
				setIsLoading(true)
				let data = await api
					.updateServiceRequest({
						...notesDetailsLPM,
						bNeedToTalkToSP: null,
						nResourceInstanceId:
							selectedService["nResourceInstanceId"],
					})
					.then(() => {
						setIsLoading(false)
						toast("Note saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					});

				setNotesDetailsLPM({
					sFollowupNotes: "",
					dtFollowupOn: "",
					sNotes: "",
				});
			}
			toggleLPMNotesModal();
		} catch (error) {
			setIsLoading(false)
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const assignToMeClick = async (e) => {
		let nResourceInstanceIds = servicesLPMByUserId[e].map(
			(f) => f["nResourceInstanceId"]
		);
		const loggedInHH = getUser();

		const data = await api
			.assignToMe({
				nResourceInstanceIds: nResourceInstanceIds,
			})
			.then((response) => {
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				} else {
					toast("Service Requests assigned successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}

				getAllServices();
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getUserData = async () => {
		let searchFilterParams;
		if (servicesLPM.length > 0) 
		{
			if (searchTerm) {
				if (phonePattern.test(searchTerm)) {
					searchFilterParams = {
						SearchBy: "contact_number",
						SearchValue: searchTerm,
					};
				} else if(emailPattern.test(searchTerm)){
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: servicesLPM[0].sEmailAddress,
					};
				}

				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		SearchBy: "email",
				// 		SearchValue: servicesLPM[0].sEmailAddress,
				// 	};
				// }
				// else{
				// 	if (phonePattern.test(searchTerm)) {
				// 		searchFilterParams = {
				// 			SearchBy: "contact_number",
				// 			SearchValue: searchTerm,
				// 		};
				// 	} else{
				// 		searchFilterParams = {
				// 			SearchBy: "email",
				// 			SearchValue: searchTerm,
				// 		};
				// 	}
				// }
				
			}
			if(searchFilterParams?.SearchValue)
			{
				const wp_user = await api
				.getUserProfileWP(searchFilterParams)
				.then((d) => {
					setUserDataWP(d);
				});
			}
			const { data } = await api.getUserProfileData({
				nUserId: servicesLPM[0]["nUserId"],
			});
			if (data) setUserData(data);
    //   sortServicesLPMByUserId();
		}
		//Added by abhijit for migrated services
		else if(servicesSPMSectionA.length>0)
		{

			if (searchTerm) {
				if (phonePattern.test(searchTerm)) {
					searchFilterParams = {
						SearchBy: "contact_number",
						SearchValue: searchTerm,
					};
				} else if(emailPattern.test(searchTerm)){
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: servicesSPMSectionA[0]["sEmailAddress"],
					};
				}

				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		SearchBy: "email",
				// 		SearchValue: servicesSPMSectionA[0]["sEmailAddress"],
				// 	};
				// }
				// else{
				// 	if (phonePattern.test(searchTerm)) {
				// 		searchFilterParams = {
				// 			SearchBy: "contact_number",
				// 			SearchValue: searchTerm,
				// 		};
				// 	} else {
				// 		searchFilterParams = {
				// 			SearchBy: "email",
				// 			SearchValue: searchTerm,
				// 		};
				// 	}
				// }
			}

			if(searchFilterParams?.SearchValue)
			{
				const wp_user = await api
				.getUserProfileWP(searchFilterParams)
				.then((d) => {
					setUserDataWP(d);
				});
			}
			
			const { data } = await api.getUserProfileData({
				nUserId: servicesSPMSectionA[0]["nUserId"],
			});
			if (data) setUserData(data);
    //   sortServicesLPMByUserId();
		}
		
		 
		  
	};

	const resetUserIdCheck = () => {
		prevUserIdRef.current = null;
	};
  const prevUserIdRef = useRef(null);

	useEffect(() => {
		// sortServicesLPMByUserId();
		const currentService =
		  servicesLPM?.[0] || servicesSPMSectionA?.[0];
	  
		if (!currentService?.nUserId) return; 
	  
		const currentUserId = currentService.nUserId;
	  
		if (!prevUserIdRef.current || prevUserIdRef.current !== currentUserId) {
	  
		  getUserData();
	  
		  prevUserIdRef.current = currentUserId;
		}
	  }, [servicesLPM, servicesLS, servicesSPMSectionA]);


	useEffect(() => {
		sortUserDataByUserId();
	}, [userDataWP]);
	// useEffect(() => {
	// 	sortServicesLS();
	// }, [servicesLPMByUserId]);
	useEffect(() => {
		sortServicesLS();
	}, [servicesLS]);
	
	// useEffect(() => {
	// 	getUserData();
	// 	sortServicesLPMByUserId();
	// }, [servicesLPM,servicesLS,servicesSPMSectionA]);
	//}, [servicesLPM, servicesLS); removed by abhijit for migrated services user profile
	useEffect(() => {
		sortServicesSPMSectionAByUserId();
	}, [servicesSPMSectionA]);
	useEffect(() => {
		sortServicesSPMSectionBByUserId();
	}, [servicesSPMSectionB]);
	useEffect(() => {
		if (searchTerm && !emailPattern.test(searchTerm) && !phonePattern.test(searchTerm)) {
		getServicesLS();
		}
	}, [servicesLPM,servicesSPMSectionA]);

	const updateTotalusers = () => {
		let tempTotalUsers = [];
		if (Object.keys(servicesLSSorted).length > 0) {
			Object.entries(servicesLSSorted).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false && key !=='null') {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesLPMByUserId).length > 0) {
			Object.entries(servicesLPMByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false && key !=='null') {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesSPMSectionAByUserId).length > 0) {
			Object.entries(servicesSPMSectionAByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false && key !=='null') {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesSPMSectionBByUserId).length > 0) {
			Object.entries(servicesSPMSectionBByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false && key !=='null') {
					tempTotalUsers.push(key);
				}
			});
		}
		setTotalUsers(tempTotalUsers);
	};
	useEffect(() => {
		updateTotalusers();
	}, [
		servicesLPMByUserId,
		servicesSPMSectionAByUserId,
		servicesSPMSectionBByUserId,
		servicesLSSorted,
	]);
	const getServicesSPMSectionA = async (instance = false, flag = false) => {
		const version = requestVersionRef.current;
		const controller = window.__axiosGlobalAbortController__;
		setServicesSPMSectionA([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {

				if (phonePattern.test(searchTerm)) {
					searchFilterParams = {
						Service_phone: searchTerm,
					};
				} else if(emailPattern.test(searchTerm)){
					searchFilterParams = {
						Service_email: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						nResourceInstanceId: searchTerm,
					};
				}

				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		nResourceInstanceId: searchTerm,
				// 	};
				// }
				// else
				// {
				// 	if (phonePattern.test(searchTerm)) {
				// 		searchFilterParams = {
				// 			Service_phone: searchTerm,
				// 		};
				// 	} else {
				// 		searchFilterParams = {
				// 			Service_email: searchTerm,
				// 		};
				// 	}
				// }
			}
			const unassigned = null;
			const serviceRequestList = [];
			const followupInPast = null;
			const followupToday = null;
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const PackageList = [];
			setIsLoadingServicesSPM(true);
			const { data } = await api.getAllServicesSPM(
				page + 1,
				10,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination,
				controller?.signal
			);
			setIsLoadingServicesSPM(false);
			// let { results, count } = data;
			let results = data.map((e) => {
				if (e["customer_meta"]["email"]){
					e["sEmailAddressOrigin"] = e["sEmailAddress"]
					e["sEmailAddress"] = e["customer_meta"]["email"];
				}
				else e["sEmailAddressOrigin"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			if (version !== requestVersionRef.current) {
				// console.log(" Ignored outdated SPM-A API result");
				return;  
			  }
			setServicesSPMSectionA(results);
			setServicesSPMSectionACount(data.length);
			setIsLoading(false)
		} catch (error) {
			console.error(error);
			setIsLoading(false)
		}
	};
	const getServicesSPMSectionB = async (instance = false, flag = false) => {
		setServicesSPMSectionB([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {

				if (phonePattern.test(searchTerm)) {
					searchFilterParams = {
						C_phone: searchTerm,
					};
				} else if(emailPattern.test(searchTerm)){
					searchFilterParams = {
						C_email: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						nResourceInstanceId: searchTerm,
					};
				}

				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		nResourceInstanceId: searchTerm,
				// 	};
				// }
				// else
				// {
				// 	if (phonePattern.test(searchTerm)) {
				// 		searchFilterParams = {
				// 			C_phone: searchTerm,
				// 		};
				// 	} else {
				// 		searchFilterParams = {
				// 			C_email: searchTerm,
				// 		};
				// 	}
				// }
				
			}
			const unassigned = null;
			const serviceRequestList = [];
			const followupInPast = null;
			const followupToday = null;
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const PackageList = [];
			setIsLoadingServicesSPM(true);
			const { data } = await api.getAllServicesSPM(
				page + 1,
				10,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination,
				window.__axiosGlobalAbortController__?.signal
			);
			setIsLoadingServicesSPM(false);
			let results = data.map((e) => {
				if (e["customer_meta"]["email"]){
					e["sEmailAddressOrigin"] = e["sEmailAddress"];
					e["sEmailAddress"] = e["customer_meta"]["email"];
				}
				else e["sEmailAddressOrigin"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			setServicesSPMSectionB(results);
			setServicesSPMSectionBCount(data.length);
		} catch (error) {
			console.error(error);
		}
	};

	const getServicesLPM = async (instance = null, flag = false) => {
		const controller = window.__axiosGlobalAbortController__;
		setServicesLPM([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {
				// console.log(selectedSearchBy);

				if (phonePattern.test(searchTerm)) {
					searchFilterParams = {
						C_phone: searchTerm,
					};
				} else if(emailPattern.test(searchTerm)) {
					searchFilterParams = {
						C_email: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						nResourceInstanceID: searchTerm,
					};
				}


				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		nResourceInstanceId: searchTerm,
				// 	};
				// }
				// else
				// {
				// 	if (phonePattern.test(searchTerm)) {
				// 		searchFilterParams = {
				// 			C_phone: searchTerm,
				// 		};
				// 	} else {
				// 		searchFilterParams = {
				// 			C_email: searchTerm,
				// 		};
				// 	}
				// }				
			}
			 



			// if (instance.state.sorted.length > 0) {
			// 	const { id, desc } = instance.state.sorted[0];
			// 	sortParams = { column: id, desc };
			// }

			const unassigned = null;
			const serviceRequestList = [];
			const PackageList = [];
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const followupDates = "";
			setIsLoadingServicesLPM(true);
			const { data } = await api.getAllServiceRequests(
				page + 1,
				10,
				'',
				'',
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				failedPayments,
				'all',
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination,
				controller?.signal			);
			setIsLoadingServicesLPM(false);

			setServicesLPM(data);
			setServicesLPMCount(data.length);
			let temp = [];
		temp = data.filter((e) => e.bMovedToSPM === false);
		if (temp.length !== 0) {
			temp = temp.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				r[a.sEmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLPMByUserId(temp);
			setIsLoading(false)
		} catch (error) {
			console.error(error);
			setIsLoading(false)
		}
	};

	const getServicesLS = async () => {
		setServicesLS([]);

		try 
		{
			let sCustomerEmail='';
			if (servicesLPM.length > 0) 
			{
				sCustomerEmail=servicesLPM[0].sEmailAddress
			}
			else if(servicesSPMSectionA.length>0)
			{
				sCustomerEmail=servicesSPMSectionA[0]["sEmailAddress"]
			}

			let searchFilterParams;
			if (searchTerm) 
			{
				if (phonePattern.test(searchTerm)) 
				{
					searchFilterParams = {
						SearchBy: "Phone",
						SearchValue: searchTerm,
					};
				}
				else if(emailPattern.test(searchTerm))
				{
					searchFilterParams = {
						SearchBy: "EmailAddress",
						SearchValue: searchTerm,
					};
				}
				else{
					searchFilterParams = {
						SearchBy: "EmailAddress",
						SearchValue: sCustomerEmail,
					};
				}

				// if(selectedSearchBy==="InstanceID")
				// {
				// 	searchFilterParams = {
				// 		SearchBy: "EmailAddress",
				// 		SearchValue: sCustomerEmail,
				// 	};
				// }
				// else
				// {
				// 	if (phonePattern.test(searchTerm)) 
				// 	{
				// 		searchFilterParams = {
				// 			SearchBy: "Phone",
				// 			SearchValue: searchTerm,
				// 		};
				// 	}
				// 	else 
				// 	{
				// 		searchFilterParams = {
				// 			SearchBy: "EmailAddress",
				// 			SearchValue: searchTerm,
				// 		};
				// 	}
				// }
				// if(searchFilterParams.SearchValue)
				// {
				// 	// setIsLoadingServicesLPM(true);
				// 	const { data } = await api.getleadDetails(searchFilterParams);
				// 	// setIsLoadingServicesLPM(false);
				// 	setServicesLS(data);
				// }
				if (searchFilterParams.SearchValue) {
					const response = await api.getleadDetails(searchFilterParams);

					setServicesLS(response?.data?.data || []);
				}

			}
			
		} catch (error) {
			console.error(error);
		}
	};

	const [searchTerm, setSearchTerm] = useState();

	const onSearchClicked = () => {
		setActiveSearchType("primary");
	  
		if (hasSearchResults()) {
		  setPendingSearchAction("SEARCH_LEFT");
		  setShowConfirmPopup(true);
		  return;
		}
	  
		// Otherwise proceed normally
		performLeftSearch();
	  };

	  const performLeftSearch = () => {
		if (!searchTerm) return;
		requestVersionRef.current += 1;
	  
		setIsLoading(true);
		
		setSearchFacTerm("");
	  	setSearchTermTemp("");
	  
		setUserDataWPByUserId([]);
		setUserData([]);
		setUserDataWP([]);
		setServicesLSSorted([]);
		setServicesLPMByUserId([]);
		setServicesLPMByUserIdNew([])
		setLPMServices([]);
		setServicesLPM([]);
		setServicesLS([]);
		setServicesSPMSectionA([]);
		setServicesSPMSectionAByUserId([]);
		setServicesSPMSectionBByUserId([]);
		setTotalUsers([]);
		resetUserIdCheck();
		getAllServices();
	  };
	  

	  const clearAllSearchResults = () => {
		setUserData([]);
		setUserDataWP([]);
		setUserDataWPByUserId([]);
		setServicesLSSorted([]);
		setServicesLPMByUserId([]);
		setServicesLPMByUserIdNew([])
		setServicesSPMSectionAByUserId([]);
		setServicesSPMSectionBByUserId([]);
		setServicesLPM([]);
		setLPMServices([]);
		setServicesSPMSectionA([]);
		setServicesSPMSectionB([]);
		setServicesLS([]);
	  
		setTotalUsers([]);
	  };
	  
	useEffect(() => {
		var cntNumber = localStorage.getItem("Number")
		const user = getUser();
		if(user && user?.id == 198 && user.email == 'eeshan.bhattacharya@deasra.co.in' && user.role[0] === 20){
			setIsThreeSixtyUser(true)
		}else{
			setIsThreeSixtyUser(false)
		}
		if(cntNumber) {
			// console.log("Is Cnt", cntNumber)
			setSearchTerm(cntNumber)
			onSearchClicked()
		}else{
			setSearchTerm("")
		}

		setTimeout(() => {
			localStorage.removeItem("Number")		
			cntNumber = ''
			// console.log('GOne', cntNumber)
		}, 3000);
	}, [])

	// const removeLS = () => {
	// 	setTimeout(() => {
	// 		localStorage.removeItem("Number")
	// 		setMobile()
	// 	},5000)
	// }

	

	const onSearchByChange = (event) => {
		setSelectedSearchBy(event.target.textContent);
	};

	const onSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
	};

	const getAllServices = async() => {
		if (emailPattern.test(searchTerm) || phonePattern.test(searchTerm)) {
			getServicesLPM();
			getServicesSPMSectionA();
			// getServicesSPMSectionB();
			if(selectedSearchBy!="InstanceID")
			{
				getServicesLS();
			}			
		}
		else{
			getServicesLPM();
			getServicesSPMSectionA();
			// getServicesSPMSectionB();
		}
	};
	useEffect(() => {
		if (params.get("email")) {
			setSearchTerm(params.get("email"));
			setSearchFilter({
				value: "email",
				label: "By email",
			});
		}
	}, []);



	const [filterError, setFilterError] = useState(false);
	const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) 
		{
			setFilterError(true);
		}
	};
	let SearchByOptions=[
		 
        {
			checked: false,
			label: "Service Instance ID",
			id: "InstanceID",
            code: "InstanceID",
		},
       
        {
			checked: false,
			label: "Customer Email ID",
			id: "CustomerEmailID",
            code: "CustomerEmailID",
		},
        
        {
			checked: false,
			label: "Phone Number",
			id: "PhoneNumber",
            code: "PhoneNumber",
		},
	];

	const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
    const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
    const toggleSearchByVisibility=()=>{
        setisSearchByDropdownOpen(!isSearchByDropdownOpen);
    }

	 
	const SearchDropdownRef = useRef();
	useEffect(() => {
		if (!isSearchByDropdownOpen) return;
	  
		function handleClick(e) {
		  if (
			SearchDropdownRef.current &&
			!SearchDropdownRef.current.contains(e.target)
		  ) {
			setisSearchByDropdownOpen(false);
		  }
		}
	  
		document.addEventListener("click", handleClick);
		return () => document.removeEventListener("click", handleClick);
	  }, [isSearchByDropdownOpen]);
	  

	const close = (e) => {
		 
	    if(isSearchByDropdownOpen)
		{
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleSearchByVisibility();
		}		
	};
		
	const selectSearchBySelection = (e) => {
		if (hasSearchResults()) {
			setPendingSelectionSearchByLeft(e);
			setShowConfirmPopup(true);
			return;
		}
		
		let temp = SearchByDropdownList;
		let tempserach = SearchByDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchByDropdownList(tempserach);
	};

	//User Profile//
	const [showUserProfileModal, setUserProfileModalVisibility] = useState(
		false
	);
	//const[nResourceInstanceId,setnResourceInstanceId]=useState();
	const [nUserId, setUserId] = useState();
	const [selectedServiceRequest, setSelectedServiceRequest] = useState();
	const [sSectorNameForUserProfile, setsSectorNameForUserProfile] = useState();
	const [sBusinessNameForUserProfile, setsBusinessNameForUserProfile] = useState();
	const [nResourceInstanceIdForUserProfile, setnResourceInstanceIdForUserProfile] = useState();
	const [userProfileInitData, setUserProfileInitData] = useState({});
	const [userProfileEditableData, setUserProfileEditableData] = useState({});
	const [sCurrentServiceRequestStateForUserProfile, setsCurrentServiceRequestStateForUserProfile] = useState();
	const [refExternalServicePartnerEmailIDForFeedback, setrefExternalServicePartnerEmailIDForFeedback] = useState();

	 
	const handleOnClickUser = (e, origin) => {

		setUserId(origin["nUserId"]);
		setnResourceInstanceIdForUserProfile(origin["nResourceInstanceId"]);
		setsBusinessNameForUserProfile(origin["sBusinessName"]);
		if(origin.refExternalServicePartner&&origin.refExternalServicePartner.sServicePartnerEmail)
		{
			setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		}
		setsCurrentServiceRequestStateForUserProfile(origin.refCurrentState&&origin.refCurrentState.sServiceState||"");
		if(origin.refBusinessSectorNew)
		{
			setsSectorNameForUserProfile(origin.refBusinessSectorNew.sSectorName);
		}
		else
		{
			setsSectorNameForUserProfile(null);
		}
		
		toggleUserProfileModal();		
	};


	 
	// const toggleUserProfileModal = () => {
	// 	setUserProfileModalVisibility(!showUserProfileModal);
	// };

	const[selectednUserIdforProfile,setselectednUserIdforProfile]=useState(); 
	const toggleUserProfileModal = (nUserId) => {
		setselectednUserIdforProfile(nUserId);
		setUserProfileModalVisibility(!showUserProfileModal);
	};

	const handleUserProfileDataChanged = (name, value) => {
		const updated = {
			...userProfileEditableData,
			[name]: value,
		};
		setUserProfileEditableData(updated);
	};

	const createUserProfile = async () => {
		try {
		} catch (error) {}
	};

	const updateSelectedServiceRequest = (data) => {
		setSelectedServiceRequest(data);
	};
  const fetchFacilitatorDetails = useCallback(async (param) => {
    try {
      const { data } = await api.getFacilitatorDetails(param);
      if (data) {
        setFacilitatorData(data);
        setFacilitatorModalVisibility(true);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  const onFacilitatorDetailsClicked = () => {
	setActiveSearchType("secondary");
  
	if (hasSearchResults()) {
	  setPendingSearchAction("SEARCH_RIGHT");
	  setShowConfirmPopup(true);
	  return;
	}
  
	performRightSearch();
  
  }

  const performRightSearch = () => {
	if (!searchFacTerm) return;
    requestVersionRef.current += 1;
	const isCheckedFacilitator = SearchByServiceDropdownList.find(item => item.checked);
  
	// Case 1: Search Type = Facilitator
	if (isCheckedFacilitator?.code === "Facilitator") {
  
	  let filterParameters = {};
  
	  if (phonePattern.test(searchFacTerm)) {
		filterParameters.sContactNumber = searchFacTerm;
	  } else if (emailPattern.test(searchFacTerm)) {
		filterParameters.sEmailAddress = searchFacTerm;
	  } else {
		filterParameters.nResourceInstanceId = searchFacTerm;
	  }
	  setSearchTerm(""); 
	  clearAllSearchResults();
	  fetchFacilitatorDetails(filterParameters);
	  return;
	}
	setSearchTerm("")
	// Case 2: Other Search Types
	clearAllSearchResults();
	setIsLoading(true);
	setSearchTermTemp(searchFacTerm);
  
	fetchServices("LPM", { term: searchFacTerm });
	fetchServices("SPM-A", { term: searchFacTerm });
  };
  


	  const cancelAllApiRequests = () => {
		requestVersionRef.current += 1;
		if (window.__axiosGlobalAbortController__) {
		  window.__axiosGlobalAbortController__.abort(); 
		}
	  
		// Create a new controller for future requests
		window.__axiosGlobalAbortController__ = new AbortController();
	  };

	  const onConfirmSelection = () => {
		cancelAllApiRequests();
		setShowConfirmPopup(false);
	  
		let clearLeft = false;
		let clearRight = false;
	  
		// LEFT DROPDOWN
		if (pendingSelectionSearchByLeft) {
		  setSearchByDropdownList((prev) =>
			prev.map((x) => ({ ...x, checked: x.code === pendingSelectionSearchByLeft }))
		  );
		  clearLeft = true;
		}
	  
		// RIGHT DROPDOWN
		if (pendingSelectionSearchByRight) {
		  setSearchByFacilitatorDropdownList((prev) =>
			prev.map((x) => ({ ...x, checked: x.code === pendingSelectionSearchByRight }))
		  );
		  setDisableFacilitatorButton(pendingSelectionSearchByRight === "CustomerEmailID");
	  
		  clearLeft = true;
		  clearRight = false;
		}
	  
		// SEARCH TYPE DROPDOWN
		if (pendingSelectionSearchType) {
		  setSearchByServiceDropdownList((prev) =>
			prev.map((x) => ({ ...x, checked: x.code === pendingSelectionSearchType }))
		  );
		  setDisableFacilitatorButton(pendingSelectionSearchType === "CustomerEmailID");
	  
		  clearLeft = true;
		  clearRight = false;
		}
	  
		// CLEAR INPUTS
		if (clearLeft) {
		  setSearchTerm("");
		  setSearchTermTemp("");
		}
		if (clearRight) {
		  setSearchFacTerm("");
		}
	  
		// ALWAYS CLEAR RESULTS
		clearAllSearchResults();
	  
		// 🔥 FIRE PENDING SEARCH ACTION (CRITICAL FIX)
		if (pendingSearchAction === "SEARCH_LEFT") {
		  performLeftSearch();
		}
		if (pendingSearchAction === "SEARCH_RIGHT") {
		  performRightSearch();
		}
	  
		// RESET pending actions
		setPendingSelectionSearchByLeft(null);
		setPendingSelectionSearchByRight(null);
		setPendingSelectionSearchType(null);
		setPendingSearchAction(null);
	  };
	  
	  
	  
	  
	  const onCancelSelection = () => {
		setShowConfirmPopup(false);
		setPendingSelectionSearchByLeft(null);
		setPendingSelectionSearchByRight(null);
		setPendingSelectionSearchType(null);
	  };
	  



    const fetchServices = useCallback(
      async (type, { term = null, flag = false } = {}) => {
		const controller = window.__axiosGlobalAbortController__;
		const version = requestVersionRef.current;
        try {
          const page = 0;
          let searchFilterParams = null;
          let sortParams = null;
  
          const forFacilitator = false;
          const forLS = false;
  
          if (type === "LPM" || type === "LPM-NEW") {
            if (term) {
              if (phonePattern.test(term)) searchFilterParams = { C_phone: term };
              else if (emailPattern.test(term)) searchFilterParams = { C_email: term };
              else searchFilterParams = { nResourceInstanceID: term };
            }
            if (type === "LPM") setIsLoadingServicesLPM(true);
            const { data } = await api.getAllServiceRequests(
              page + 1,
              10,
              "",
              "",
              [],
              [],
              null,
              [],
              null,
              "all",
              "all",
              [],
              searchFilterParams,
              sortParams,
              flag,
              false,
			  controller?.signal);
            if (type === "LPM") {
				if (version !== requestVersionRef.current) {
					// console.log(" Ignored outdated SPM-A API result");
					return;  
				  }
              setServicesLPM(data);
              setLPMServices(data);
			  setServicesLPMCount(data.length);
              setIsLoading(false);
              setIsLoadingServicesLPM(false);
			  let temp = [];
		temp = data.filter((e) => e.bMovedToSPM === false);
		if (temp.length !== 0) {
			temp = temp.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				r[a.sEmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLPMByUserId(temp);
            } else {
				if (version !== requestVersionRef.current) {
					// console.log(" Ignored outdated SPM-A API result");
					return;  
				  }
              setLPMServices(data);
			  setServicesLPM(data);
			  setServicesLPMCount(data.length);
				let temp = [];
				temp = data.filter((e) => e.bMovedToSPM === false);
				if (temp.length !== 0) {
					temp = temp.reduce((r, a) => {
						r[a.sEmailAddress] = r[a.sEmailAddress] || [];
						r[a.sEmailAddress].push(a);
						return r;
					}, Object.create(null));
				}
				setServicesLPMByUserId(temp);
              setIsLoading(false);
            }
          } else if (type === "SPM-A" || type === "SPM-NEW") {
            if (term) {
              if (phonePattern.test(term)) searchFilterParams = { Service_phone: term };
              else if (emailPattern.test(term)) searchFilterParams = { Service_email: term };
              else searchFilterParams = { nResourceInstanceId: term };
            }
            if (type === "SPM-A") setIsLoadingServicesSPM(true);
            const { data } = await api.getAllServicesSPM(
              page + 1,
              10,
              [],
              [],
              null,
              [],
              null,
              null,
              null,
              "all",
              [],
              searchFilterParams,
              sortParams,
              flag,
              false,
			  controller?.signal            );
            const results = (data || []).map((e) => {
              if (e?.customer_meta?.email) {
                e["sEmailAddressOrigin"] = e["sEmailAddress"];
                e["sEmailAddress"] = e["customer_meta"]["email"];
              } else e["sEmailAddressOrigin"] = "";
              e["refSRState"] = e?.refCurrentState?.sServiceState || "";
              e["refFacilitator"] = e?.refFacilitator?.email || "";
              return e;
            });
			if (version !== requestVersionRef.current) {
				// console.log(" Ignored outdated SPM-A API result");
				return;  
			  }
            if (type === "SPM-A") {
              setServicesSPMSectionA(results);
              setIsLoadingServicesSPM(false);
              setIsLoading(false);
            } else {
              setSPMServices(results);
              setIsLoading(false);
            }
          } else if (type === "SPM-B") {
            if (term) {
              if (phonePattern.test(term)) searchFilterParams = { Service_phone: term };
              else if (emailPattern.test(term)) searchFilterParams = { Service_email: term };
              else searchFilterParams = { nResourceInstanceId: term };
            }
          }
        } catch (err) {
          console.error(err);
          setIsLoadingServicesLPM(false);
          setIsLoading(false);
          setIsLoadingServicesSPM(false);
        }
      },
      []
    );

    const toggleFacilitatorModal = useCallback(() => {
      setFacilitatorModalVisibility(false);
      setFacilitatorData("");
    }, []);

    const getUserDataForService = useCallback(
      async (service, setUserDataFn, setUserDataWPFn, sortLPMByUserIdFn) => {
        if (!service || !service.nUserId) return;
        let searchFilterParams = null;
        const term = searchFacTerm || service.sEmailAddress;
        if (term) {
          if (phonePattern.test(term)) {
            searchFilterParams = { SearchBy: "contact_number", SearchValue: term };
          } else if (emailPattern.test(term)) {
            searchFilterParams = { SearchBy: "email", SearchValue: term };
          } else {
            searchFilterParams = { SearchBy: "email", SearchValue: service.sEmailAddress };
          }
        }
        // console.log("searchFilterParams?.SearchValue::::",searchFilterParams?.SearchValue)
        // try {
        //   if (searchFilterParams?.SearchValue) {
        //     const d = await api.getUserProfileWP(searchFilterParams);
        //     if (d?.data?.data?.[0]?.email) setUserDataWPFn(d);
        //     else setUserDataWPFn([]);
        //   }
  
        //   const { data } = await api.getUserProfileData({ nUserId: service.nUserId });
        //   if (data) setUserDataFn(data);
        //   // sorting/grouping is now memoized, so no explicit call needed
        // } catch (err) {
        //   console.error(err);
        // }
      },
      [searchTerm]
    );

    const prevUserIdNewRef = useRef(null);
    const [userDataNew, setUserDataNew] = useState();
    const [userDataWPNew, setUserDataWPNew] = useState([]);
    useEffect(() => {
      const currentService = LPMServices?.[0] || SPMServices?.[0];
      if (!currentService?.nUserId) return;
      const currentUserId = currentService.nUserId;
      if (!prevUserIdNewRef.current || prevUserIdNewRef.current !== currentUserId) {
        prevUserIdNewRef.current = currentUserId;
        getUserData(currentService, setUserDataNew, setUserDataWPNew, null);
      }
    }, [LPMServices, SPMServices, getUserDataForService]);
  
    useEffect(() => {
      function handleDocumentClick(e) {
        if (isSearchByDropdownOpen && SearchDropdownRef.current && !SearchDropdownRef.current.contains(e.target)) {
          setisSearchByDropdownOpen(false);
        }
        if (isSearchByFacilitatorDropdownOpen && SearchDropdownFacilitatorRef.current && !SearchDropdownFacilitatorRef.current.contains(e.target)) {
          setIsSearchByFacilitatorDropdownOpen(false);
        }
        if (isSearchByServiceDropdownOpen && SearchDropdownServiceRef.current && !SearchDropdownServiceRef.current.contains(e.target)) {
          setisSearchByServiceDropdownOpen(false);
        }
      }
      if (isSearchByDropdownOpen || isSearchByFacilitatorDropdownOpen || isSearchByServiceDropdownOpen) {
        document.addEventListener("click", handleDocumentClick);
        return () => document.removeEventListener("click", handleDocumentClick);
      }
      return;
    }, [isSearchByDropdownOpen, isSearchByFacilitatorDropdownOpen, isSearchByServiceDropdownOpen]);

	useEffect(() => {
		function updateHeaderHeight() {
		  const header = document.getElementById("fixed-header");
		  if (header) {
			const height = header.offsetHeight + "px";
			document.documentElement.style.setProperty("--dynamic-header-height", height);
		  }
		}
	  
		requestAnimationFrame(() => {
		  requestAnimationFrame(() => {
			updateHeaderHeight();
		  });
		});
	  
		if (document.fonts?.ready) {
		  document.fonts.ready.then(() => {
			updateHeaderHeight();
		  });
		}
	  
		window.addEventListener("resize", updateHeaderHeight);
		return () => window.removeEventListener("resize", updateHeaderHeight);
	  }, []);
	//
	// useDebouncedEffect(
	// 	() => {
	// 		getAllServices();
	// 	},
	// 	1000,
	// 	[searchTerm]
	// );
	return (
		<div style={{ justifyContent: "center" }}>
			{isLoading && (
				<div className="loader360degree">
					<Spinner />
				</div>
			)}

      {/* <div className="col-12 lpm-filter-section conv-pl40 conv-pr40 conv-fixeds-headerss"> */}
	  <div id="fixed-header" className="col-12 lpm-filter-section conv-pl40 conv-pr40 conv-fixeds-headerss">
        <div className="row conv-mt20 conv-pl20">
          <div className="col-12">
            {/* <div className="row conv-pr5 conv-mr15  conv-align-self-center conv-float-left"> */}
			<div className="row conv-pr5 conv-mr15 conv-align-self-center d-flex justify-content-between align-items-center flex-wrap">
              <div className="conv-pr5 conv-mr15">
                <button
                  className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                  onClick={onSearchClicked}
                >
                  Search
                </button>

                <input
                  type="text"
                  className="conv-float-right form-control conv-h250rem search-input "
                  placeholder="Search"
                  onChange={handleSearchInputChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") onSearchClicked();
                  }}
                  value={searchTerm}
                  name="searchTerm"
                />

                {/* <div
                  className="btnes-searchs-by conv-float-right con-cursor-pointer"
                  onClick={() => {
                    toggleSearchByVisibility();
                  }}
                >
                  <span className="spans-texts-searchs-by">Search By</span>
                  <img alt="" src={select_arrow_down} height={"12px"} width={"12px"} className="conv-ml10" />
                </div>
                {isSearchByDropdownOpen && (
                  <div className="searchs-by" ref={SearchDropdownRef}>
                    <RadioSelectionDropdown
                      isOpen={isSearchByDropdownOpen}
                      toggleSelection={selectSearchBySelection}
                      checkboxItemsList={SearchByDropdownList}
                    />
                  </div>
                )} */}
                <div className="search-wrapper" style={{ display: "inline-block", position: "relative" }}>
  <div
    className="btnes-searchs-by conv-float-right con-cursor-pointer"
    onClick={toggleSearchByVisibility}
  >
    <span className="spans-texts-searchs-by">Search By</span>
    <img alt="" src={select_arrow_down} height="12" width="12" className="conv-ml10" />
  </div>

  {isSearchByDropdownOpen && (
                  <div className="searchs-by-new" ref={SearchDropdownRef}>
                    <RadioSelectionDropdown
                      isOpen={isSearchByDropdownOpen}
                      toggleSelection={selectSearchBySelection}
                      checkboxItemsList={SearchByDropdownList}
                    />
                  </div>
                )} 
</div>
              </div>

              <span
                className="conv-pr5 conv-mr15 conv-mt6 conv-font14"
                style={{ fontWeight: 900, padding: "3px 8px", borderRadius: "4px" }}
              >
                <h2>or</h2>

              </span>
              <div className="conv-pr5 conv-mr15">
                <button
                  className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                  onClick={onFacilitatorDetailsClicked}
                >
                  Search
                </button>
                <div
                  className="btnes-searchs-by conv-float-right con-cursor-pointer"
                  onClick={() => {
                    toggleSearchByServiceVisibility();
                  }}
                >
                  <span className="spans-texts-searchs-by">Search-Type</span>
                  <img alt="" src={select_arrow_down} height={"12px"} width={"12px"} className="conv-ml5" />
                </div>

                <input
                  type="text"
                  className="conv-float-right form-control conv-h250rem search-input "
                  placeholder="Search"
                  onChange={handleSearchFacInputChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") onSearchClicked();
                  }}
                  value={searchFacTerm}
                  name="searchTerm"
                />

               
<div className="search-wrapper" style={{ display: "inline-block", position: "relative" }}>
  <div
    className="btnes-searchs-by conv-float-right con-cursor-pointer"
    onClick={toggleSearchByFacilitatorVisibility}
  >
    <span className="spans-texts-searchs-by">Search By</span>
    <img alt="" src={select_arrow_down} height="12" width="12" className="conv-ml10" />
  </div>

  {isSearchByFacilitatorDropdownOpen && (
    <div className="searchs-by-new" ref={SearchDropdownFacilitatorRef}>
      <RadioSelectionDropdown
        isOpen={isSearchByFacilitatorDropdownOpen}
        toggleSelection={selectSearchByFacilitatorSelection}
        checkboxItemsList={SearchByFacilitatorDropdownList}
      />
    </div>
  )}
  {isSearchByServiceDropdownOpen && (
                  <div className="searchs-by-fac" ref={SearchDropdownServiceRef}>
                    <RadioSelectionDropdown
                      isOpen={isSearchByServiceDropdownOpen}
                      toggleSelection={selectSearchByServiceSelection}
                      checkboxItemsList={SearchByServiceDropdownList}
                    />
                  </div>
                )}
</div>


                
              </div>
			  {isThreeSixtyUser ?
			  	(
					<div className="conv-float-right linkNew360-view-text conv-pl10"/>
				)
				:
             	(<a href="/home/facilitator-service-progression/" target="_blank" rel="noreferrer" className="conv-float-right linkNew360-view-text conv-pl10">
                To My Services
              	</a>
				)}
            </div>
          </div>
        </div>

        {totalUsers.length !== 0 ? (
          <>
            <div className="conv-ml20 conv-mt15">
              Showing Results For : <span style={{ fontWeight: "bold" }}>{searchTerm ? searchTerm : searchTermTemp}</span>
            </div>
          </>
        ) : (
          <span className="conv-ml20 conv-mt15">No data to display</span>
        )}
      </div>
            {totalUsers.length === 0 ? (
        <span>No data to display</span>
      ) : (
        <>
        {activeSearchType === "primary" && (
          <ServicessDetailsContainer
            totalUsers={totalUsers}
            userDataWP={userDataWPByUserId}
            userData={userData}
            servicesLSSortedByUserId={servicesLSSorted}
            servicesLPMByUserId={servicesLPMByUserId}
            servicesSPMSectionAByUserId={servicesSPMSectionAByUserId}
            servicesSPMSectionBByUserId={servicesSPMSectionBByUserId}
            toggleNotesModal={toggleNotesModal}
			toggleLPMNotesModal={toggleLPMNotesModal}
            assignToMeClick={assignToMeClick}
            toggleViewAllNotesModal={(email) => {
              setselectedCustomerEmailForNotes(email);
              setShowViewAllNotesModal((v) => !v);
            }}
            toggleViewAllSMSModal={(email) => {
              setselectedCustomerEmailForNotes(email);
              setShowViewAllSMSModal((v) => !v);
            }}
            toggleUserProfileModal={toggleUserProfileModal}
			isLoadingServicesLPM={isLoadingServicesLPM}
    		isLoadingServicesSPM={isLoadingServicesSPM}
			mainLoader={isLoading}
          />
          )}
          
          {activeSearchType === "secondary" && (
          <ServiceDetailsNewContainer
            totalUsers={totalUsers}
            userDataWP={userDataWPByUserId}
            userData={userData}
            servicesLSSortedByUserId={servicesLSSorted}
            servicesLPMByUserId={servicesLPMByUserId}
            servicesSPMSectionAByUserId={servicesSPMSectionAByUserId}
            servicesSPMSectionBByUserId={servicesSPMSectionBByUserId}
            toggleNotesModal={toggleNotesModal}
			toggleLPMNotesModal={toggleLPMNotesModal}
            assignToMeClick={assignToMeClick}
            toggleViewAllNotesModal={(email) => {
              setselectedCustomerEmailForNotes(email);
              setShowViewAllNotesModal((v) => !v);
            }}
            toggleViewAllSMSModal={(email) => {
              setselectedCustomerEmailForNotes(email);
              setShowViewAllSMSModal((v) => !v);
            }}
            toggleUserProfileModal={toggleUserProfileModal}
			isLoadingServicesLPM={isLoadingServicesLPM}
    		isLoadingServicesSPM={isLoadingServicesSPM}
			mainLoader={isLoading}
          />
          )}
        </>
      )}

      <NotesModalThreeSixtyDegreeView isOpen={showNotesModal} toggleModal={toggleNotesModal} onInputChange={onInputChange} notesDetails={notesDetails} onSaveNotesDetails={onSaveNotesDetails} />
      <NotesLPMModalThreeSixtyDegreeView isOpen={showLPMNotesModal} toggleModal={toggleLPMNotesModal} onInputChange={onLPMInputChange} notesDetails={notesDetailsLPM} onSaveNotesDetails={onSaveLPMNotesDetails} />

      {showViewAllNotesModal && <CentralizedNotesModal isOpen={showViewAllNotesModal} toggleModal={() => setShowViewAllNotesModal((v) => !v)} sEmailAddress={selectedCustomerEmailForNotes || ""} />}

      {showViewAllSMSModal && <CentralizedSMSLogModal isOpen={showViewAllSMSModal} toggleModal={() => setShowViewAllSMSModal((v) => !v)} sEmailAddress={selectedCustomerEmailForNotes || ""} />}

      {showUserProfileModal && (
        <ProfileThreeSixtyModal
          isOpen={showUserProfileModal}
          toggleModal={toggleUserProfileModal}
          toggleUserProfileModal={handleOnClickUser}
          userProfileInitData={userProfileInitData}
          userProfileEditableData={userProfileEditableData}
          onInputChange={(name, val) => setUserProfileEditableData((p) => ({ ...p, [name]: val }))}
          createUserProfile={() => {}}
          updateSelectedServiceRequest={() => {}}
          nUserId={selectednUserIdforProfile || ""}
          nResourceInstanceIdForUserProfile={nResourceInstanceIdForUserProfile}
          showFacilitatorEngagementView={false}
          sBusinessNameForUserProfile={sBusinessNameForUserProfile}
          sSectorNameForUserProfile={sSectorNameForUserProfile}
          sCurrentServiceRequestStateForUserProfile={sCurrentServiceRequestStateForUserProfile}
          refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
        />
      )}

      <FacilitatorThreeSixtyModel isOpen={facilitatorModalVisibility} toggleModal={toggleFacilitatorModal} facilitatorData={facilitatorData || ""} toggleViewAllNotesModal={() => setShowViewAllNotesModal((v) => !v)} searchTerm={searchTerm} />
	  {showConfirmPopup && (
  <div className="confirm-modal-overlay">
    <div className="confirm-modal">
      <p className="confirm-message">
	  <strong>This action will clear your current search results</strong>.
        <br /><strong>Do you want to continue?</strong> </p>

      <div className="confirm-buttons">
        <button className="confirm-btn cancel" onClick={onCancelSelection}>
          No, Keep Results
        </button>

        <button className="confirm-btn confirm" onClick={onConfirmSelection}>
          Yes, Continue
        </button>
      </div>
    </div>
  </div>
)}


    </div>
	);
}
